import { useState } from 'react';

import { getLocalStorage } from '../../../common/utils/localStorageHandler';

import { localStorageKeyCompanyCode, localStorageKeyUserCode } from '../../../common/const/commonConst';
import { OffsegAuthInfoType } from '../../feature/type/AuthInfoType';

/**
 * ログイン時に入力するOffsegログイン情報の状態管理用カスタムフック
 */
export const useStateOffsegLoginAuthInfo = () => {
	// ローカルストレージからデータを取得
	const companyCode = getLocalStorage(localStorageKeyCompanyCode);
	const userCode = getLocalStorage(localStorageKeyUserCode);

	const initOffsegAuthInfo = {
		companyCode: companyCode,
		userCode: userCode,
		password: '',
	};

	const [offsegLoginAuthInfo, setOffsegLoginAuthInfo] = useState<OffsegAuthInfoType>(initOffsegAuthInfo); // Offsegのログイン情報の管理

	return {
		offsegLoginAuthInfo,
		setOffsegLoginAuthInfo,
	};
};
